import { Component, OnInit } from '@angular/core';

import { CommonDTO } from 'app/model/common-dto';
import { CommonService } from 'app/service/common.service';
import { UserAppAccessLogDTO } from 'app/model/user-app-access-log-dto';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {
  commonDTO: CommonDTO = new CommonDTO();
  userAppAccessLogDTO: UserAppAccessLogDTO = new UserAppAccessLogDTO();
  parsedJson: any;
  appLatestReleaseVersion: string = '';

  constructor(private commonService: CommonService) { }
  ngOnInit() {
    this.getUserAppAccessLog();
    this.getAppReleaseVersion();
  }

  getUserAppAccessLog() {
    this.commonService.getUserAppAccessLog(this.commonDTO)
      .subscribe(data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.userAppAccessLogDTO = this.parsedJson;
      }, (error) => {

      });
  }

  getAppReleaseVersion() {
    this.commonService.getAppLatestReleaseVersion()
      .subscribe(data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.appLatestReleaseVersion = this.parsedJson.releaseVersion;
      }, (error) => {

      });
  }

}


